import { PlusOutlined } from '@ant-design/icons'
import { Row, Col, Radio, Button } from 'antd'
import { orderBy } from 'lodash'
import {
  HAS_CONCLUSIONS,
  HAS_CONCLUSIONS_OBJECT,
  SUB_SECTION_TYPE,
  SUB_SECTION_TYPE_OBJECT,
} from '../../constant'
import CollapseHeader from '../CollapseHeader/CollapseHeader'
import TemplateCheckPoint from '../TemplateCheckPoint/TemplateCheckPoint'
import './TemplateSubSection.style.less'
import { isEmptyValue } from '@/utils/common'
import MarkdownEditor from '../MarkdownEditor/MarkdownEditor'
interface Props {
  index: any
  subIndex: any
  subItem: any
  onSubSectionNameChange: (index, subIndex, value) => void
  onDeleteSubSection: (index, subIndex) => void
  onAddCheckpoint: (index, subIndex) => void
  onDeleteCheckpoint: (index, subIndex, checkpointIndex) => void
  onCheckpointNameChange: (index, subIndex, checkpointIndex, value) => void
  onSubSectionHasConclusion: (index, subIndex, value) => void
  onSubSectionType: (index, subIndex, value) => void
  onChangeCheckpointControlType: (
    index,
    subIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointMandatory: (index, subIndex, checkpointIndex, value) => void
  onAddDataSource: (index, subIndex, checkpointIndex, value) => void
  onRemoveDatasource: (
    index,
    subIndex,
    checkpointIndex,
    datasourceIndex
  ) => void
  onSubSectionInstructionChange: (index, subIndex, value) => void
  onCheckPointHidden: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointHasDefaultValue: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointDefaultValueChange: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
}

function TemplateSubSection(props: Props) {
  return (
    <div key={props.subIndex} className="sub-section-header-container">
      <Row>
        <Col span={1} />
        <div className="sub-section-name-container">
          <CollapseHeader
            title="Sub Section Name"
            value={props.subItem}
            onChangeName={(value) =>
              props.onSubSectionNameChange(props.index, props.subIndex, value)
            }
            onDeleteSection={() =>
              props.onDeleteSubSection(props.index, props.subIndex)
            }
          />
        </div>
      </Row>
      <Row
        style={{ paddingBottom: 15 }}
        align={'top'}
        className="sub-section-option-container"
      >
        <Col span={2} />
        <Col span={5}>
          <p className="label">Options</p>
        </Col>
        <Col>
          <Radio.Group
            size="large"
            onChange={(e) =>
              props.onSubSectionType(
                props.index,
                props.subIndex,
                e.target.value
              )
            }
            value={
              props.subItem.options?.subSectionType ??
              SUB_SECTION_TYPE_OBJECT.STANDARD.value
            }
          >
            {SUB_SECTION_TYPE.map((item) => {
              return (
                <Radio key={item.label} value={item.value}>
                  {item.label}
                </Radio>
              )
            })}
          </Radio.Group>

          <Row style={{ marginTop: 4 }}>
            <p className="sub-label">Has a Conclusions result</p>
            <Radio.Group
              size="large"
              onChange={(e) =>
                props.onSubSectionHasConclusion(
                  props.index,
                  props.subIndex,
                  e.target.value
                )
              }
              value={
                !isEmptyValue(props.subItem.options?.hasConclusion)
                  ? props.subItem.options?.hasConclusion
                  : HAS_CONCLUSIONS_OBJECT.NO.value
              }
            >
              {HAS_CONCLUSIONS.map((item) => {
                return (
                  <Radio key={item.label} value={item.value}>
                    {item.label}
                  </Radio>
                )
              })}
            </Radio.Group>
          </Row>
        </Col>
      </Row>
      <MarkdownEditor
        onChanged={(value) =>
          props.onSubSectionInstructionChange(
            props.index,
            props.subIndex,
            value
          )
        }
        markdown={props.subItem.options?.instruction}
      />
      {orderBy(props.subItem?.checkpoints, ['index'], ['asc'])?.map(
        (checkPoint, cIndex) => {
          return (
            <TemplateCheckPoint
              item={checkPoint}
              key={cIndex}
              checkpointIndex={cIndex}
              index={props.index}
              subIndex={props.subIndex}
              onDeleteCheckpoint={props.onDeleteCheckpoint}
              onCheckpointNameChange={props.onCheckpointNameChange}
              onChangeCheckpointControlType={
                props.onChangeCheckpointControlType
              }
              onCheckPointMandatory={props.onCheckPointMandatory}
              onAddDataSource={props.onAddDataSource}
              isSelect={
                checkPoint.control_type == 'select' ||
                checkPoint.control_type == 'select_dropdown' ||
                checkPoint.control_type == 'multi_select' ||
                checkPoint.control_type == 'editable_entry_list'
              }
              datasource={checkPoint.datasource}
              onRemoveDatasource={props.onRemoveDatasource}
              onCheckPointHidden={props.onCheckPointHidden}
              onCheckPointHasDefaultValue={props.onCheckPointHasDefaultValue}
              onCheckPointDefaultValueChange={
                props.onCheckPointDefaultValueChange
              }
            />
          )
        }
      )}
      <div className="add-checkpoint-button-container">
        <Button
          onClick={() => props.onAddCheckpoint(props.index, props.subIndex)}
          className="add-checkpoint-button"
        >
          <PlusOutlined className="plus-icon" />
          Add a Checkpoint
        </Button>
      </div>
    </div>
  )
}

export default TemplateSubSection
